module.exports = __webpack_public_path__ + "img/hopways-02.fa2ce33f.webp";